import { Injectable } from '@angular/core';
import { UserService } from './user.service';

@Injectable({
  providedIn: 'root'
})
export class HeaderService {
  private menu:any[]=[];
  constructor(private _userService:UserService) { }

  cargarMenu(){
    this.menu=this._userService.getMenu();
    return this.menu;
  }

}
